export function isAbortError(err: any): boolean {
  return (
    err?.name === "AbortError" ||
    err?.code === 20 ||
    (typeof err?.message === "string" &&
      /abort|aborted|ERR_CANCEL(L|ED)/i.test(err.message)) ||
    err?.cause?.name === "AbortError"
  );
}

export function ignoreAbort(err: unknown) {
  if (isAbortError(err)) return;
  console.error(err);
}
